import React from "react";
import "../../styles/About/ThreeDots.scss";

const ThreeDots = () => {
  return (
    <section
      id="home"
      className="wrapper d-flex align-items-center justify-content-center"
    >
      <div className="circle1"></div>
      <div className="circle2"></div>
      <div className="circle3"></div>
      {/* <div className="shadow1"></div>
        <div className="shadow2"></div>
        <div className="shadow3"></div> */}
    </section>
  );
};

export default ThreeDots;
